export const SaveToken = (token) => {
  // console.log('token: ', token);
  localStorage.setItem('access_token', `${token}`);
};

export const SaveUserInfo = (name, userId, userRole, firstPasswordChanged, profilePicture, deptId) => {
  localStorage.setItem('name', `${name}`);
  localStorage.setItem('userId', userId);
  localStorage.setItem('userRole', userRole);
  localStorage.setItem('firstPasswordChanged', firstPasswordChanged);
  localStorage.setItem('profilePicture', profilePicture);
  localStorage.setItem('deptId', deptId);
};

export const GetToken = () => {
  return localStorage.getItem('access_token');
};

export const IsManager = () => {
  const r = localStorage.getItem('isManager');
  // console.log(r);
  return r;
};
